// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6346":"ae4b1c27","6765":"b1e1b76e"}[chunkId] + ".chunk.css";
};